import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  NgZone,
  ViewChild
} from '@angular/core';
import { PieChartData } from '../models/PieChartData';
import {
  DEFAULT_PIE_CHART_COLORS,
  DEFAULT_CHART_FONT,
  DEFAULT_CHART_FONT_SIZE
} from '../charts.constants';

declare let AmCharts: any;

@Component({
  selector: 'app-pie-chart',
  template:
    '<div #pieChartCont style="width: 100%;" [style.height]="height"></div>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PieChartComponent implements AfterViewInit {
  @Input() data: Array<PieChartData>;
  @Input() colors: Array<string> = DEFAULT_PIE_CHART_COLORS;
  @Input() height = '280px';
  @Input() minRadius = 10;
  @Input() fullPie = false;
  @Input() hideLegend = false;
  @ViewChild('pieChartCont', { static: true }) pieChartCont: ElementRef;

  constructor(private _ngZone: NgZone) {}

  ngAfterViewInit() {
    try {
      this._ngZone.runOutsideAngular(() => {
        const dataProvider: PieChartData[] = [];
        let totalValue = 0;
        this.data.forEach((item, index) => {
          if (index < 5) {
            dataProvider.push(item);
          } else {
            totalValue += item?.value;
          }
        });

        if (totalValue > 0) {
          dataProvider.push({
            value: totalValue,
            category: 'Others',
            title: 'Others'
          });
        }

        const sovChart = new AmCharts.AmPieChart(AmCharts.themes['light']);
        sovChart.categoryField = 'category';
        sovChart.valueField = 'value';
        sovChart.titleField = 'title';
        sovChart.dataProvider = dataProvider;
        sovChart.fontFamily = DEFAULT_CHART_FONT;
        sovChart.fontSize = DEFAULT_CHART_FONT_SIZE;
        sovChart.maxLabelWidth = 100;
        sovChart.labelWidth = 100;
        if (this.fullPie) {
          sovChart.radius = 100;
          sovChart.minRadius = this.minRadius;
        } else {
          sovChart.radius = 85;
          sovChart.innerRadius = 40;
        }
        sovChart.forceWidth = true;
        sovChart.labelText = '[[title]]';
        sovChart.colors = this.colors;

        if (!this.hideLegend) {
          var legend = new AmCharts.AmLegend();
          legend.position = 'right';
          legend.fontSize = 14;
          legend.markerType = 'circle';
          legend.switchType = 'v';
          legend.valueText = ``;
          legend.switchable = false;
          sovChart.addLegend(legend);
        } else {
          sovChart.removeLegend();
        }

        sovChart.write(this.pieChartCont.nativeElement);

        this._ngZone.run(() => {
          console.debug('PIE Chart render done!');
        });
      });
    } catch (e) {
      console.log('ERROR on PIE Chart: ', e);
    }
  }
}
